<template>

  <page-container noSteps>
    <template slot="description">
      <div>Комплексы упражнений • {{ complex.name }}</div>
    </template>
    <template slot="title">

      <div class="complex-content__header header">
        <div class="header__item" :style="{ opacity: stickyStyle ? 0 : 1  }">
          <el-input v-if="editableTitle"
                    v-model="complex.name"
                    placeholder="Введите название..."
                    @blur="setEditableTitle"
                    class="header__input"></el-input>
          <div v-else class="header__title">{{ complex.name }}</div>
          <div @click="setEditableTitle" class="header__edit">
            <save-icon v-if="complex.name && editableTitle" class="edit-icon"/>
            <i v-else-if="complex.name && !editableTitle" class="el-icon-edit edit-icon"></i>
          </div>
        </div>

      </div>
    </template>

    <div class="complex">

      <div class="complex-container" id="-session-block">
        <div class="complex-content">

          <div v-loading="loading"  class="complex-content__block">

            <div class="panel">
              <div class="panel__left">

                <div class="name">

                  <span class="name__text">Комплекс упражнений для системы: </span>
                  <el-select v-if="editableSystemType || !humanSystemTypeTitle"
                             v-model="humanSystemTypeId"
                             @change="setEditableSystemType(true)"
                             placeholder="Выберите..."
                             class="name__select">
                    <el-option v-for="item in humanSystemTypes"
                               :key="item.id"
                               :label="item.title"
                               :value="item.id">
                    </el-option>
                  </el-select>
                  <template v-else>{{ humanSystemTypeTitle }}</template>
                  <div @click="setEditableSystemType" class="name__edit">
                    <save-icon v-if="editableSystemType || !humanSystemTypeTitle" class="edit-icon"/>
                    <i v-else-if="humanSystemTypeTitle" class="el-icon-edit edit-icon"></i>
                  </div>
                </div>

                <div class="name">
                  <span class="name__text">Cпециалист:</span>
                  <el-select v-if="editableSpecialistName || !specialistName"
                             v-model="specialistName"
                             placeholder="Выберите..."
                             class="name__select">
                    <el-option label="Иванов А.А." value="Иванов А.А."></el-option>
                  </el-select>
                  <template v-else>{{ specialistName }}</template>
                  <div @click="setEditableSpecialistName" class="name__edit">
                    <save-icon v-if="editableSpecialistName" class="edit-icon"/>
                    <i v-else-if="specialistName" class="el-icon-edit edit-icon"></i>
                  </div>
                </div>

              </div>

              <el-button type="text"
                         class="panel__button"
                         @click="removeAllExercises">
                Удалить все
              </el-button>

            </div>

            <div class="exercises">
              <exercise-item :newItem="true"
                             :exercise="newExercise"
                             @save="saveNewExercise"></exercise-item>
              <exercise-item v-loading="loading"
                             v-for="(exercise, index) in complex.data"
                             :key="index"
                             :index="index"
                             :exercise="exercise"
                             @remove="removeExercise"></exercise-item>
            </div>

          </div>

          <div class="button">
            <el-button type="primary" v-loading="loading"
                       @click="save">Сохранить</el-button>
            <el-button @click="close">Закрыть</el-button>
          </div>

        </div>
      </div>
    </div>

  </page-container>

</template>

<script>
import SaveIcon from "@/components/icons/Save"
import ExerciseItem from "@/components/complexExercises/ExerciseItem.vue"
import PageContainer from "@/components/elements/PageContainer";

import {mapGetters, mapActions} from "vuex"

export default {
  name: "ComplexExercises.item",
  components: {
    SaveIcon,
    ExerciseItem,
    PageContainer
  },
  data() {
    return {
      loading: false,
      editableTitle: false,
      editableSystemType: false,
      editableSpecialistName: false,
      complex: {
        name: "",
        data: []
      },
      humanSystemTypeId: null,
      humanSystemTypeTitle: "",
      specialistName: "",
      newExercise: {
        name: "",
        files: [],
        description: "",
        exercise_time: "",
        exercise_approach: ""
      },
      contentScroll: 0,
    }
  },
  computed: {
    ...mapGetters({
      humanSystemTypes: "complexExercises/humanSystemTypes"
    }),
    complexId() {
      return this.$route.params.id
    },
    stickyStyle() {
      return this.contentScroll >= 10 ? true : false
    },
    titlePage() {
      return this.$route.meta.title
    },
  },
  async created() {
    await this.init()

  },
  methods: {
    ...mapActions({
      getComplexData: "complexExercises/getComplexData",
      sendComplex: "complexExercises/sendComplex",
      getHumanSystemTypes: "complexExercises/getHumanSystemTypes",
      startLoadingList: "complexExercises/startLoadingList"
    }),
    init() {
      if (!this.humanSystemTypes) {
        this.getHumanSystemTypes()
      }
      if (this.complexId) {
        this.getComplex(this.complexId)
      }
      if (!this.complex.name) {
        this.editableTitle = true
      }
    },
    getComplex(id) {
      this.loading = true
      this.getComplexData(id)
        .then(response => {
          this.complex = response
          this.humanSystemTypeId = response.human_system_type.id
          this.humanSystemTypeTitle = response.human_system_type.title
          if (this.complex.name) this.editableTitle = false
        })
        .catch(() => {
          this.$notify.error({
            title: "Ошибка загрузки комплекса 😕"
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveComplex() {

      if(this.complex.data.length === 0) {
        this.$notify.warning({
          title: "Введите хотя бы одно упражнение",
          message: 'Для сохранения упражнения нажмите на иконку дискеты',
        })

        return
      }
      if(!this.complex.name) {
        this.$notify.warning({
          title: "Введите название комплекса",
          message: '',
        })

        return
      }

      this.loading = true

      let payload = {
        id: this.complex.id ? this.complex.id : null,
        human_system_type_id: this.humanSystemTypeId,
        name: this.complex.name,
        data: this.complex.data
      }
      this.sendComplex(payload).then(() => {
        this.$notify.success({
          title: "Успешно",
        })

        this.$router.push({name: "complexExercises.list"})
        this.startLoadingList()

        this.loading = false

      }, error => {
        this.loading = false
        this.$notify.error({
          title: "Ошибка сохранения 😕",
          message: error.response.data.message,
        })
      })
    },
    setEditableTitle() {
      if(!this.complex.name) {
        this.editableTitle = true
      } else {
        this.editableTitle = !this.editableTitle
      }
    },
    setEditableSystemType(close) {

      this.editableSystemType = close === true ? false : !this.editableSystemType
      const systemType = this.humanSystemTypes.find(type => type.id === this.humanSystemTypeId)

      this.humanSystemTypeTitle = systemType.title
    },
    setEditableSpecialistName() {
      this.editableSpecialistName = !this.editableSpecialistName
    },
    save() {
      this.saveComplex()

    },
    close() {
      this.$router.push({name: "complexExercises.list"})
    },
    saveNewExercise(item) {
      this.newExercise= {
        name: "",
            files: [],
            description: "",
            exercise_time: "",
            exercise_approach: ""
      }
      this.complex.data.push(item)
    },
    removeExercise(index) {
      this.complex.data.splice(index, 1)
    },
    editScroll(t) {
      this.contentScroll = t
    },
    removeAllExercises() {
      this.complex.data = []
    }
  }
}
</script>

<style scoped lang="scss">


.complex-container {
  width: 100%;
  margin: 0 auto;


  box-sizing: border-box;
  overflow-y: auto;
}

.complex-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;


  &__sub-title {
    margin: 4px 0 16px 0;
    padding: 0;

    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.015em;
    color: #8E8E93;
  }
}

.header {
  width: max-content;

  &__item {
    display: flex;
    align-items: center;

    transition: all .2s ease;
  }

  &__input {
    max-width: 360px;

    /deep/ input {
      padding: 8px 16px !important;

      font-weight: 600;
      font-size: 22px;
      line-height: 26px;
      letter-spacing: 0.015em;
    }
  }

  &__title {
    margin-top: 0;
    margin-bottom: 0;

    font-weight: 600;
    font-size: 22px;
    line-height: 26px;
    color: #000;

    &--sticky {
      position: fixed;
      top: 0;
      z-index: 2001;

      margin-top: 20px;

      font-size: 19px;
    }
  }

  &__edit {
    margin-left: 17px;
  }
}

.panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  &__left {
    display: flex;
    align-items: center;
  }

  &__button {
    padding: 0 !important;


    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.005em;

    color: #078065;

    &:hover {
      text-decoration: underline;
    }
  }
}

.name {
  display: flex;
  align-items: center;
  margin-right: 33px;

  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.005em;
  color: #111111;

  &__text {
    margin-right: 3px;
  }

  &__select {
    width: 110px;
  }

  &__edit {
    margin-left: 8px;
  }
}

.edit-icon {
  color: #8E8E93;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    opacity: 0.5
  }
}

.exercises {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px 16px;

  @media (max-width: 1199px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.button {
  max-width: 1200px;
  margin-top: 24px;
}

/deep/ .el-loading-mask {
  background-color: rgba(239, 239, 244, .87) !important;
}
</style>
